import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=ec0fc49e&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=js&"
export * from "./Metadata.vue?vue&type=script&lang=js&"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=ec0fc49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0fc49e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec0fc49e')) {
      api.createRecord('ec0fc49e', component.options)
    } else {
      api.reload('ec0fc49e', component.options)
    }
    module.hot.accept("./Metadata.vue?vue&type=template&id=ec0fc49e&scoped=true&", function () {
      api.rerender('ec0fc49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/Metadata.vue"
export default component.exports